import { Injectable } from "@angular/core";
import { AbstractThemingService } from "@vault/angular/services/theming/theming.service.abstraction";
import { ThemeType } from "@vault/common/enums/themeType";
import { toObservable } from "@angular/core/rxjs-interop";
import { distinctUntilChanged, filter, map, switchMap, from } from "rxjs";

import { UserStoreService } from "@vault/web-vault/app/services/store/user/user.store.service";

@Injectable({
  providedIn: "root",
})
export class UserThemeService {
  private preference$ = toObservable(this.userStore.preferences.preferenceView);

  constructor(
    private userStore: UserStoreService,
    private themingService: AbstractThemingService,
  ) {
    this.preference$
      .pipe(
        // null = preferences not loaded yet (or cleared on logout): keep the current theme.
        // A loaded preference with no saved theme gets the app default, not the previous user's.
        filter((pref) => pref != null),
        map((pref) => pref.theme ?? ThemeType.Light),
        distinctUntilChanged(),
        switchMap((theme) => from(this.themingService.updateConfiguredTheme(theme))),
      )
      .subscribe();
  }
}
